module.exports = __webpack_public_path__ + "static/media/cvo-street-glide-sunset-orange.0e4d6d53.png";